import { type ReactNode } from 'react'
import { useTeam } from '@front/model'
import { useToastError } from '@hooks'
import { type WithTeamId, type WithUserId } from '@terros/common'
import { NotReady } from 'app/components/NotReady'
import { UserTeamMembership } from './UserTeamMembership'

type Props = WithTeamId & WithUserId

export const ViewTeamMembership = ({ teamId, userId }: Props): ReactNode => {
  const { data: teamData, isLoading: isLoadingTeam, error: teamError } = useTeam(teamId)
  useToastError(teamError)

  const userMembership = teamData?.members.find((member) => member.user.userId === userId)

  if (isLoadingTeam || !teamData || teamError)
    return <NotReady data={teamData} error={teamError} isLoading={isLoadingTeam} />

  if (!userMembership) return

  return <UserTeamMembership teamData={teamData} userMembership={userMembership} />
}
